import { render, staticRenderFns } from "./leaderListSec.vue?vue&type=template&id=2b417d82&scoped=true"
import script from "./leaderListSec.vue?vue&type=script&lang=js"
export * from "./leaderListSec.vue?vue&type=script&lang=js"
import style0 from "./leaderListSec.vue?vue&type=style&index=0&id=2b417d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b417d82",
  null
  
)

export default component.exports